import React, { useEffect, useMemo, useState } from "react";
import objectPath from "object-path";
import ApartmentOutlinedIcon from "@material-ui/icons/ApartmentOutlined";
import TodayOutlinedIcon from "@material-ui/icons/TodayOutlined";
import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";
import { useLocation } from "react-router-dom";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { QuickUserToggler } from "../extras/QuiclUserToggler";
import { baseUrl } from "../../../../services/config";
import { useUnitSettings } from "../../../../context/UnitSettingsContext";
import "./topbar-enhancements.css";

export function Topbar() {
  const location = useLocation();
  const { settings } = useUnitSettings();
  const unitName = settings?.unit_name || "";
  const [isOnline, setIsOnline] = useState(
    typeof navigator === "undefined" ? true : navigator.onLine,
  );
  const [isServerOk, setIsServerOk] = useState(true);
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      viewQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      viewCartDisplay: objectPath.get(uiService.config, "extras.cart.display"),
      viewQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
    };
  }, [uiService]);

  const today = new Date().toLocaleDateString("en-PK", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    if (!isOnline) return;

    let isActive = true;

    const checkServer = async () => {
      try {
        const res = await fetch(`${baseUrl}/health`, { method: "GET" });
        const data = await res.json();

        if (isActive) {
          setIsServerOk(data.status === "ok");
        }
      } catch {
        if (isActive) {
          setIsServerOk(false);
        }
      }
    };

    checkServer();

    return () => {
      isActive = false;
    };
  }, [isOnline, location.pathname, location.search]);

  let userDetails = {};
  if (localStorage.getItem("userDetails")) {
    userDetails = JSON.parse(localStorage.getItem("userDetails"));
  }

  const roleValue = userDetails?.role?.[0] || userDetails?.roles?.[0] || "User";
  const role =
    typeof roleValue === "object"
      ? roleValue?.name || roleValue?.role_name || "User"
      : roleValue;
  return (
    <div className="topbar modern-topbar">
      <div className="modern-topbar-unit">
        <span className="modern-topbar-unit-icon">
          <ApartmentOutlinedIcon />
        </span>
        <strong>{unitName || "School Unit"}</strong>
      </div>

      <div className="modern-topbar-actions">
        <div
          className={`modern-topbar-status ${
            !isOnline ? "offline" : !isServerOk ? "server-issue" : "online"
          }`}
        >
          <i />
          <span>
            {!isOnline ? "Connection Lost" : !isServerOk ? "Server Issue" : "System Online"}
          </span>
        </div>

        <div className="modern-topbar-chip role">
          <VerifiedUserOutlinedIcon />
          <span>{role}</span>
        </div>

        <div className="modern-topbar-chip">
          <TodayOutlinedIcon />
          <span>{today}</span>
        </div>

        {layoutProps.viewUserDisplay && <QuickUserToggler />}
      </div>
    </div>
  );
}
